/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_LoginInputs */

const zh_auth_login = /** @type {(inputs: Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const en_auth_login = /** @type {(inputs: Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const es_auth_login = /** @type {(inputs: Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Auth_LoginInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login = /** @type {((inputs?: Auth_LoginInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_LoginInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_login(inputs)
	if (locale === "en") return en_auth_login(inputs)
	return es_auth_login(inputs)
});